module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_90_100.e5c467f3.png";